module.exports = __webpack_public_path__ + "img/emoji_55.53a82278.png";